import React, { useState, useCallback, useMemo, useEffect, useRef } from 'react';
import Button from '../../../../components/common/Button';
import { encode, decode } from 'hexie-encode';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTitle } from '../../../../hooks/misc';
import $$ from 'whi18n';

const HexieEncoder = () => {
	useTitle($$`hexie-encoder`);

	const [input, setInput] = useState('');
	const [customDict, setCustomDict] = useState('');
	const [output, setOutput] = useState('');
	const [copied, setCopied] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();
	const outputComp = useRef(null);
	const inputComp = useRef(null);

	const search = useMemo(() => new URLSearchParams(location.search), [location.search]);
	const act = search.get('act') || 'decode';
	const dict = decodeURI(search.get('dict') || '');
	const txt = decodeURI(search.get('txt') || '');

	const dictArr = useMemo(() => {
		let d = customDict || dict;
		if (!d) return undefined;

		if (/^(?:[^\s,，]+[\s,，]){2,}/[Symbol.match](d)) {
			return d.split(/[\s,，]/).map(e => e.trim()).filter(Boolean);
		}
		return d.split('').map(e => e.trim()).filter(Boolean);
	}, [customDict, dict]);

	const onClickEncode = useCallback(() => {
		navigate(
			location.pathname +
				'?act=encode' +
				(customDict ? `&dict=${encodeURI(customDict)}` : '') +
				(input ? `&txt=${encodeURI(input)}` : ''),
			{ replace: true }
		);
	}, [customDict, input, location.pathname, navigate]);

	const onClickDecode = useCallback(() => {
		navigate(
			location.pathname +
				'?act=decode' +
				(customDict ? `&dict=${encodeURI(customDict)}` : '') +
				(input ? `&txt=${encodeURI(input)}` : ''),
			{ replace: true }
		);
	}, [customDict, input, location.pathname, navigate]);

	const doEncode = useCallback(
		(txt, dict) => {
			try {
				const result = dict && dict.length > 2 ? encode(txt, dict) : encode(txt);
				setOutput(result);
			} catch (ex) {
				console.error(ex);
				setOutput('');
			}
		},
		[setOutput]
	);

	const doDecode = useCallback(
		(txt, dict) => {
			try {
				const result = dict && dict.length > 2 ? decode(txt, dict) : decode(txt);
				setOutput(result);
			} catch (ex) {
				setOutput('');
			}
		},
		[setOutput]
	);

	useEffect(() => {
		if (txt) {
			setInput(txt);
		}

		if (dict) {
			setCustomDict(dict);
		}

		if (act) {
			if (act === 'decode') {
				doDecode(txt, dictArr);
			} else {
				doEncode(txt, dictArr);
			}
		}
	}, [act, txt, dict]);

	const onClickOutput = useCallback(() => {
		outputComp.current.select();
		outputComp.current.setSelectionRange(0, 999999);
		document.execCommand('copy');
		setCopied(true);

		setTimeout(() => setCopied(false), 700);
	}, [output, outputComp]);

	const onFocusInput = useCallback(() => {
		inputComp.current.select();
		inputComp.current.setSelectionRange(0, 999999);
	}, [inputComp]);

	return (
		<div className="HexieEncoder">
			<h1>{$$`hexie-encoder`}</h1>
			<textarea
				onChange={({ target: { value } }) => {
					setOutput('');
					setInput(value);
				}}
				value={input}
				ref={inputComp}
				onFocus={onFocusInput}
			></textarea>
			<div className="button-area">
				<Button onClick={onClickEncode}>{$$`hexie.encode`}</Button>
				<Button onClick={onClickDecode}>{$$`hexie.decode`}</Button>
			</div>
			<textarea value={copied ? $$`hexie.copied` : output} readOnly={true} onClick={onClickOutput} ref={outputComp}></textarea>
			<h2>{$$`hexie.custom-dict`}</h2>
			<input
				className="custom-dict"
				type="text"
				placeholder="富强 民主 文明 和谐 自由 平等 公正 法治 爱国 敬业 诚信 友善"
				onChange={({ target: { value } }) => {
					setOutput('');
					setCustomDict(value);
				}}
				value={customDict}
			/>
		</div>
	);
};

export default HexieEncoder;
